import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-customer-request-dialog',
  templateUrl: './delete-customer-request-dialog.component.html',
  styleUrls: ['./delete-customer-request-dialog.component.css']
})
export class DeleteCustomerRequestDialogComponent implements OnInit {

  formGroup: FormGroup;

  constructor(
    private _ref: MatDialogRef<DeleteCustomerRequestDialogComponent>,
    private _formBuilder: FormBuilder
  ) {
    this.formGroup = this._formBuilder.group({
      deleteIssues: false,
      deleteContracts: false
    });
  }

  close = () => this._ref.close(false);

  confirm = () => this._ref.close(this.formGroup.value);

  ngOnInit(): void {
    
  }

}
